module.exports = __webpack_public_path__ + "images/xyz1-995b028c6ec0fe2eecbb1cdb50fe526c.jpg";